import { ThunkAction, ThunkDispatch } from "@reduxjs/toolkit";

import { ReduxState, ThunkExtraArgument } from "@dashboard/types";

import type { ErrorReducerAction } from "../reducers/errorReducer";
import { SupplierReducerAction } from "../reducers/supplierReducer";
import { addError } from "./addErrorAction";

export type SupplierThunkDispatch = ThunkDispatch<
  ReduxState,
  ThunkExtraArgument,
  SupplierReducerAction | ErrorReducerAction
>;

type ThunkActionReturn = ThunkAction<
  Promise<void>,
  ReduxState,
  ThunkExtraArgument,
  SupplierReducerAction
>;

export const fetchSuppliers = () => {
  return async (
    dispatch: SupplierThunkDispatch,
    getState: () => ReduxState,
    { supplierApi }: ThunkExtraArgument
  ) => {
    const state = getState();
    const selectedRestaurant = state.restaurant.selectedRestaurant;

    return supplierApi
      .fetchSuppliers(selectedRestaurant?.uuid)
      .then((suppliers) => {
        dispatch({
          type: "FETCHED_SUPPLIERS",
          payload: suppliers,
        } as SupplierReducerAction);
      })
      .catch(addError(dispatch));
  };
};

// Bulk deletes restaurant suppliers (only restaurant suppliers can be deleted, not central suppliers)
export const bulkDeleteRestaurantSuppliers: (
  restaurantUuid: string,
  supplierIds: string[]
) => ThunkActionReturn = (restaurantUuid: string, supplierIds: string[]) => {
  return (
    dispatch: SupplierThunkDispatch,
    getState: () => ReduxState,
    { supplierApi }: ThunkExtraArgument
  ) => {
    return supplierApi
      .bulkDeleteRestaurantSuppliers(restaurantUuid, supplierIds)
      .then(() => {
        dispatch({ type: "DELETE_SUPPLIERS", payload: supplierIds });
      })
      .catch(addError(dispatch));
  };
};
